var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidgetBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.987,4H3V28H29v-.963l-25-.05L3.987,4ZM17,5a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1V25h5Zm-6,6a1,1,0,0,0-1-1H7a1,1,0,0,0-1,1V25h5Zm12,6a1,1,0,0,0-1-1H19a1,1,0,0,0-1,1v8h5Zm5,5H25a1,1,0,0,0-1,1v2h5V23A1,1,0,0,0,28,22Z",
    transform: "translate(-3 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetBar);
export default __webpack_public_path__ + "static/media/widget-bar.195c4527.svg";
export { ForwardRef as ReactComponent };